import { GAME_ID, REDUX_ACTIONS, onboardingSteps, SCREENS } from '../../../data/constants';
import { worksheetActionTypes } from '../../../../components/worksheet/data/constants';

export const initialState = {
  // general purpose
  inOnboarding: false,
  onboardingType: 'singleImage',
  onboardingStep: onboardingSteps.NONE,

  // local state tracking
  bigIdeaHasBeenDefined: false,
  hasAskedQuestion: false,
  isItemComplete: false,
  isBlockingReplayButton: false,

  // for the `?` button
  isOnlyDoingOnboarding: false,
};

const onboardingReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_IN_ONBOARDING:
      return {
        ...state,
        inOnboarding: payload,
        isItemComplete: false,
      };

    case REDUX_ACTIONS.SET_ONBOARDING_STEP: {
      let { bigIdeaHasBeenDefined } = state;

      if (payload === onboardingSteps.DEFINE_BIG_IDEA) {
        if (!bigIdeaHasBeenDefined) {
          bigIdeaHasBeenDefined = true;
        } else {
          return state; // don't re-define the concept of a big idea. That can get pretty obnoxious pretty quickly.
        }
      }
      return {
        ...state,
        onboardingStep: payload,
        bigIdeaHasBeenDefined,
      };
    }

    case REDUX_ACTIONS.SET_SINGLE_IMAGE_ZOOM:
    case REDUX_ACTIONS.SET_COMIC_ZOOM:
    case REDUX_ACTIONS.SET_SCROLLVIEW_LEFT_ALIGNED: {
      if (payload === true) {
        const { bigIdeaHasBeenDefined } = state;
        if (!bigIdeaHasBeenDefined) {
          return {
            ...state,
            onboardingStep: onboardingSteps.DEFINE_BIG_IDEA,
            bigIdeaHasBeenDefined: true,
          };
        }
      }
      // set-left-aligned doesn't come with a payload.
      if (payload === false || type === REDUX_ACTIONS.SET_SCROLLVIEW_LEFT_ALIGNED) {
        const { hasAskedQuestion } = state;
        if (!hasAskedQuestion) {
          return {
            ...state,
            onboardingStep: onboardingSteps.QUESTION,
            hasAskedQuestion: true,
          };
        }
      }
      return state;
    }

    case REDUX_ACTIONS.SET_CAROUSEL_INTERACTIONS_ENABLED:
      if (state.bigIdeaHasBeenDefined && state.hasAskedQuestion && !state.isItemComplete && payload === true) {
        return {
          ...state,
          onboardingStep: onboardingSteps.CALL_TO_ACTION,
        };
      }
      return state;

    case worksheetActionTypes.ON_CORRECT_START:
      return {
        ...state,
        onboardingStep: onboardingSteps.CORRECT_FEEDBACK,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN:
      switch (payload) {
        case SCREENS.MULTI_IMAGE:
        case SCREENS.SINGLE_IMAGE:
        case SCREENS.TEXT:
        case SCREENS.VARIETY:
          return {
            ...state,
            onboardingType: payload,
          };
        default:
          return {
            ...initialState,
          };
      }

    case REDUX_ACTIONS.SET_IS_ITEM_COMPLETE:
      return {
        ...state,
        isItemComplete: payload,
      };

    case REDUX_ACTIONS.SET_IS_ONLY_DOING_ONBOARDING:
      return {
        ...state,
        isOnlyDoingOnboarding: payload,
      };

    case REDUX_ACTIONS.SET_BLOCKING_REPLAY_BUTTON:
      return {
        ...state,
        isBlockingReplayButton: payload,
      };

    default:
      return state;
  }
};

export default onboardingReducer;
